import React from "react";

import "./amenity.css";
import {
  CardContent,
  CardMedia,
  Container,
  Paper,
  Typography,
} from "@mui/material";

type AmenityProps = {
  title: string;
  description: string;
  image: string;
};

function Amenity(props: AmenityProps) {
  const { title, description, image } = props;

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
      }}
      elevation={0}
    >
      <Container
        sx={{ height: "40%", display: "flex", justifyContent: "center" }}
      >
        <CardMedia
          component="img"
          sx={{
            objectFit: "contain",
            maxWidth: "100%",
            maxHeight: "100%",
            width: "auto",
            height: "auto",
          }}
          image={image}
          title="Una imagen de una amenidad"
        />
      </Container>

      <CardContent>
        <Typography gutterBottom variant="h6" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
    </Paper>
  );
}

export default Amenity;
